// Components==============
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axios from "axios";
// =========================

export const getCategories = async () => {
  const { data } = await axios.get("/api/categories");
  return data as CategoryEntity[];
};

export default function useGetCategories(
  options?: UseQueryOptions<CategoryEntity[]>
) {
  const query = useQuery<CategoryEntity[]>({
    queryKey: ["categories"],
    queryFn: getCategories,
    ...options,
  });

  return query;
}
